export enum ParkingType {
  RESERVED = 'RESERVED',
  UNRESERVED = 'UNRESERVED',
  MOTORCYCLE = 'MOTORCYCLE',
  ELECTRIC = 'ELECTRIC',
}
